/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Loader from "../../components/Loader/Loader";
import admin from "../../public/images/telgrosadmin.svg";
import { verifyFlutterwaveTransaction } from "../../Redux/expertSlice";

const PaymentVerification = () => {
  const dispatch = useDispatch();

  const params = new URLSearchParams(window.location.search);

  const status = params.get("status");
  const transaction_id = params.get("transaction_id");
  const tx_ref = params.get("tx_ref");
  const hasPaymentParams = Boolean(status);

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isapiCalled, setIsapiCalled] = useState(false);
  const verifyPayment = async () => {
    try {
      setIsLoading(true);
      const payload1 = {
        status,
        transaction_id,
        tx_ref,
      };
      console.log("payload1_payload1", payload1);
      const response = await dispatch(
        verifyFlutterwaveTransaction(payload1)
      );

      console.log("response_response", response);
      setIsSuccess(Boolean(response?.payload?.data?.isSuccess));
    } catch (error) {
      setIsSuccess(false);
    } finally {
      setIsapiCalled(true);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (!hasPaymentParams) return;

    verifyPayment();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#212B36] px-4">
      <Loader loading={isLoading} />
      <div className="w-full max-w-xl p-6 bg-white shadow-md sm:p-10 rounded-xl">
        <img className="mx-auto mb-6 w-44" src={admin} alt="Admin logo" />

        {isapiCalled && (
          <div className="text-center">
            <p className="text-[18px] font-semibold mb-2">
              {isSuccess ? "Payment Successful 🎉" : "Payment Failed ❌"}
            </p>
            <p className="text-gray-700 mb-6">
              {isSuccess
                ? "Your payment has been processed successfully."
                : "Your payment was not completed."}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentVerification;
